import { Box } from '@mui/joy';

import { ICompanySettings } from 'auth/types';
import { Loader } from 'core/elements';
import { QuoteEntityType } from 'quotes/enums';
import { IQuoteVersionData } from 'quotes/types';
import { Level, Size } from 'theme/enums';

import { ChangeFreightButton } from './ChangeFreightButton';
import { FreightValue } from './FreightValue';
import { Wrapper } from './style';
import { getFreightRow } from './utils';

interface IProps {
  quoteVersionData: IQuoteVersionData;
  freightSettings?: Pick<ICompanySettings, 'defaultFreightPercentage' | 'minimumFreightCharge'>;
  partsTotal?: number;
  classNames?: string;
  isLoading?: boolean;
  quoteEntityType?: QuoteEntityType;
  isEditable?: boolean;
  onSubmitSuccess?: () => void;
}

export const FreightRow = ({
  quoteVersionData,
  freightSettings = {},
  partsTotal = 0,
  classNames = '',
  isLoading = false,
  quoteEntityType = QuoteEntityType.QUOTE,
  isEditable = false,
  onSubmitSuccess,
}: IProps) => {
  if (isLoading) {
    return (
      <Wrapper>
        <Loader size={Size.SM} style={{ margin: 0 }} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Box>{getFreightRow(quoteVersionData, { classNames, freightSettings })}</Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FreightValue
          quoteVersionData={quoteVersionData}
          freightSettings={freightSettings}
          classNames={classNames}
          valueProps={{ level: Level.BODY_SM }}
        />

        {isEditable && (
          <ChangeFreightButton
            quoteVersionData={quoteVersionData}
            partsTotal={partsTotal}
            freightSettings={freightSettings}
            quoteEntityType={quoteEntityType}
            onSubmitSuccess={onSubmitSuccess}
          />
        )}
      </Box>
    </Wrapper>
  );
};
